module.exports = __webpack_public_path__ + "img/sticky-bg-brush.8eb00df.svg";